export default __webpack_public_path__ + "static/media/Kasala Banner_2020-03.66f0d540.png";